// Small helpers for the automatic staking payout fields.
// Numeric values may arrive as numbers or decimal strings, and several
// fields are nullable for legacy stakes.

export function toNumber(value) {
  if (value === null || value === undefined || value === "") return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
}

export function formatCoin(value) {
  const n = toNumber(value);
  if (n === null) return "—";
  return n.toLocaleString("en-US", { maximumFractionDigits: 8 });
}

export function formatUsd(value) {
  const n = toNumber(value);
  if (n === null) return null;
  return n.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function formatApy(value) {
  const n = toNumber(value);
  if (n === null || n <= 0) return null;
  return `${n.toFixed(2)}% APY`;
}

export function formatStakeDate(value) {
  if (!value) return null;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}

export function getNonSettledTotal(stakes) {
  if (!Array.isArray(stakes)) return 0;
  const total = stakes.reduce((sum, stake) => {
    if (stake?.status === "settled") return sum;
    const amount = toNumber(stake?.amount);
    return amount === null ? sum : sum + amount;
  }, 0);
  return Math.round(total * 100) / 100;
}

export function applyStakesTotal(userData, stakes) {
  if (!userData?.balances || !Array.isArray(stakes)) return userData;
  return {
    ...userData,
    balances: {
      ...userData.balances,
      total_stakes: getNonSettledTotal(stakes),
    },
  };
}